import React, { useRef } from "react";

import { DATE_FNS_SHORT_DATE_FORMAT } from "../../../shared/constants";
import { format } from "date-fns";

const getDefaultTitle = (data) =>
    `The client has exceeded the weekly product limit. Would you like to override the limit or move the shipment to week of ${format(
        new Date(data.suggested),
        DATE_FNS_SHORT_DATE_FORMAT
    )}`;

export const OverrideDates = ({ data, action, title, cancelLabel, overrideLabel, moveLabel }) => {
    const overrideButtonRef = useRef(null);
    const moveButtonRef = useRef(null);

    const resolvedTitle = title ?? data?.title ?? getDefaultTitle(data);
    const resolvedCancelLabel = cancelLabel ?? data?.cancelLabel ?? "Cancel";
    const resolvedOverrideLabel = overrideLabel ?? data?.overrideLabel ?? "Override Limit";
    const resolvedMoveLabel = moveLabel ?? data?.moveLabel ?? "Move Shipment";

    const handleCancel = () => {
        action.remove();
        action.resolve({
            cancel: true,
        });
    };

    const handleMove = () => {
        moveButtonRef.current.disabled = true;
        action.remove();
        action.resolve({
            update: false,
        });
    };

    const handleOverride = () => {
        overrideButtonRef.current.disabled = true;
        action.remove();
        action.resolve({
            update: true,
        });
    };

    return (
        <div>
            <h4 className="txt-center">{resolvedTitle}</h4>
            <div className="button-group -center">
                <button
                    className="button"
                    onClick={handleCancel}
                >
                    {resolvedCancelLabel}
                </button>
                <button
                    className="button"
                    ref={overrideButtonRef}
                    onClick={handleOverride}
                >
                    {resolvedOverrideLabel}
                </button>
                <button
                    className="button -primary"
                    ref={moveButtonRef}
                    onClick={handleMove}
                >
                    {resolvedMoveLabel}
                </button>
            </div>
        </div>
    );
};
